"use client";

import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function QuickContact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="quick-contact" ref={ref} className={`bg-muted py-16 transition-opacity duration-150 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          {}
          <div className="space-y-6">
            <h2 className="text-[28px] font-display font-semibold text-foreground mb-6">
              Call Us Today
            </h2>
            
            <div className="space-y-4">
              <Link to="tel:0876789903" className="flex items-center gap-4 p-4 bg-background rounded-md shadow-soft hover:shadow-medium transition-all duration-150 group focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
                <div className="flex items-center justify-center size-12 rounded-full bg-primary-light text-foreground shrink-0">
                  <Phone className="size-5" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground font-medium">Rathnew</p>
                  <p className="text-lg font-semibold text-foreground tracking-normal group-hover:tracking-wide group-focus:tracking-wide transition-all duration-150">
                    087 678 9903
                  </p>
                </div>
              </Link>

              <Link to="tel:0876253228" className="flex items-center gap-4 p-4 bg-background rounded-md shadow-soft hover:shadow-medium transition-all duration-150 group focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
                <div className="flex items-center justify-center size-12 rounded-full bg-primary-light text-foreground shrink-0">
                  <Phone className="size-5" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground font-medium">Wicklow</p>
                  <p className="text-lg font-semibold text-foreground tracking-normal group-hover:tracking-wide group-focus:tracking-wide transition-all duration-150">
                    087 625 3228
                  </p>
                </div>
              </Link>
            </div>
          </div>

          {}
          <div className="flex items-center justify-center md:justify-end">
            <Link to="/ContactPage">
              <Button size="lg" className="btn-primary text-base px-10 py-6 h-auto">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}